<!-- 企微用户引流 -->
<template>
  <div class="wrapper">
    <div class="imgs">
      <img
        v-for="(item, index) in imgs"
        :key="index"
        :src="item"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  },
  computed: {
    path () {
      return 'https://image.hzwxbz2.cn/java-yunying/' + (this.$route.query.path || 'jyy_1725850590280_1310a34bfe75c9c84d9565844b0a58d5.png')
    },
    imgs () {
      return [this.path]
    }
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100vw;
  min-height: 100vh;
}
.imgs {
  padding: 0;
  height: 100vh;
  font-size: 0;
  img {
    object-fit: cover;
    object-position: 50% 0%;
    width: 100%;
    height: 100%;
  }
}
</style>